import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function CreatePatientFormFields() {
  return (
    <ParentBlockSelectField
      fieldName="config.payload"
      label="Patient"
      helperText={getSourceBlockNameHelperText('patient')}
    />
  );
}
